// extracted by mini-css-extract-plugin
export default {"wrapper":"DemoNotFilledUserData_wrapper__2D7vL","image":"DemoNotFilledUserData_image__Rcot-","formWrapper":"DemoNotFilledUserData_formWrapper__nXFgP"};